// export default function VisionMission() {
//   return (
//     <section className="py-16 md:py-24 bg-gradient-to-br from-white via-purple-50 to-purple-100">
//       <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-center px-4 md:px-6">

//         <div className="relative order-1 md:order-none">
//           <img
//             src="/vision2.jpg"
//             alt="Team working together"
//             className="rounded-md shadow-lg object-cover w-full max-h-[320px] md:max-h-none"
//           />
//           <div className="absolute -bottom-4 -right-4 w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-300 opacity-40 blur-2xl"></div>
//         </div>

//         <div className="space-y-8 md:space-y-10 order-2 md:order-none">

//           <div className="bg-white rounded-2xl shadow-[0_6px_25px_rgba(100,50,255,0.12)] border border-purple-100 p-6 md:p-8 transition-transform hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(100,50,255,0.18)]">
//             <h3 className="text-center text-xl md:text-2xl font-bold text-purple-700 mb-3 md:mb-4">
//               Vision
//             </h3>
//             <p className="text-gray-700 text-center text-[0.95rem] md:text-base leading-relaxed">
//               To become the largest website design firm by emphasizing{" "}
//               <span className="text-purple-600 font-semibold">innovative thinking</span>{" "}
//               to establish ourselves as a worldwide recognized company by offering
//               the highest standard services and solutions.
//             </p>
//           </div>

//           <div className="bg-white rounded-2xl shadow-[0_6px_25px_rgba(255,180,50,0.15)] border border-orange-100 p-6 md:p-8 transition-transform hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(255,180,50,0.25)]">
//             <h3 className="text-center text-xl md:text-2xl font-bold text-orange-500 mb-3 md:mb-4">
//               Mission
//             </h3>
//             <p className="text-gray-700 text-center text-[0.95rem] md:text-base leading-relaxed">
//               To provide customer-centric, result-oriented, cost-competitive,
//               innovative and functional IT solutions to our valuable worldwide customers.
//             </p>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }
import SlideInOnScroll from "./SlideInOnScroll";

export default function VisionMission() {
  return (
    <section
      className="py-16 md:py-24 bg-cover bg-center"
      style={{ backgroundImage: "url('/vision2.jpg')" }} // 换成你的图片路径
    >
      {/* 容器：内容整体靠右 */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex justify-end">
        {/* 右侧内容区域：桌面宽度占一半，手机占满 */}
        <div className="w-full md:w-1/2 space-y-8 md:space-y-10">
          <SlideInOnScroll from="left">
            {/* Vision */}
            <div className="bg-white rounded-2xl shadow-[0_6px_25px_rgba(100,50,255,0.12)] border border-purple-100 p-6 md:p-8 transition-transform hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(100,50,255,0.18)]">
              <h3 className="text-center text-xl md:text-2xl font-bold text-purple-700 mb-3 md:mb-4">
                Vision
              </h3>
              <p className="text-gray-700 text-center text-[0.95rem] md:text-base leading-relaxed">
                <span className="text-purple-600 font-semibold">AI NOVA </span>{" "}
                aims to be the global leader in Computing Power Services,
                empowering enterprises with next-generation infrastructure to
                excel in an ever-evolving digital world. Guided by relentless
                innovation and an unwavering commitment to our customers, we are
                shaping the future of intelligent computing, delivering the
                performance, scalability, and insight that define tomorrow’s
                digital enterprise.
              </p>
            </div>
          </SlideInOnScroll>

          <SlideInOnScroll from="left" delay={0.1}>
            {/* Mission */}
            <div className="bg-white rounded-2xl shadow-[0_6px_25px_rgba(255,180,50,0.15)] border border-orange-100 p-6 md:p-8 transition-transform hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(255,180,50,0.25)]">
              <h3 className="text-center text-xl md:text-2xl font-bold text-orange-500 mb-3 md:mb-4">
                Mission
              </h3>
              <p className="text-gray-700 text-center text-[0.95rem] md:text-base leading-relaxed">
                <span className="text-orange-500 font-semibold">AI NOVA </span>{" "}
                is committed to accelerating enterprise digital transformation
                through Innovative Technologies that create measurable value for
                our customers. By leveraging state-of-the-art computing
                infrastructure and deep domain expertise, we empower
                organizations to achieve superior performance, optimize
                operations, and scale effectively, driving synergy, resilience,
                and impact across today’s dynamic digital landscape.
              </p>
            </div>
          </SlideInOnScroll>
        </div>
      </div>
    </section>
  );
}
